import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ClientContactModel } from '../../../models/client-contact.model';
import { ClientService } from '../../../services/client.service';
import { FormatPhoneNumberPipe } from '../../../pipes/formatPhoneNumber.pipe'
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'ngx-work-contacts',
  templateUrl: './contacts.component.html',
  providers: [FormatPhoneNumberPipe] 
})
export class ContactsComponent implements OnInit {

  private _client_no: number;

  @Input() set client_no(value: number) {
    this._client_no = value;
  }

  get client_no(): number {
    return this._client_no;
  }

  constructor(
    public clientService: ClientService,
    private formatPhoneNumberPipe: FormatPhoneNumberPipe,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
  }

  add() {
    this.clientService.contact = new ClientContactModel('', '', '', 0, 0, false);
    $('#modalNewFamilyContact').modal('toggle')
  }

  edit(item: ClientContactModel) {
    this.clientService.contact = item;
    this.clientService.contact.contact_no = this.formatPhoneNumberPipe.transform(item.contact_no);
    $('#modalNewFamilyContact').modal('toggle')
  }

  delete(item: ClientContactModel) {
    Swal.fire({
      title: 'Delete this contact?',
      // icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Yes'
    }).then((result: any) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Loading...',
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
          },
        })
        this.clientService.deleteClientContact(item)
          .then(() => {
            this.clientService.getClientContact(this.clientService.current_client_no)
              .then(() => {
                Swal.close();
              });
          });
      }
    });
  }
}
